import { STORAGE_KEYS } from '../types';
import {
  CategoryGroupDraft,
  OnboardingAnswers,
  createDefaultAnswers
} from './onboardingCategoryBuilder';

export function loadOnboardingAnswers(): OnboardingAnswers {
  try {
    const stored = localStorage.getItem(STORAGE_KEYS.ONBOARDING_CATEGORY_ANSWERS);
    if (stored) {
      const parsed = JSON.parse(stored);
      return { ...createDefaultAnswers(), ...parsed, debts: parsed.debts ?? [], goals: parsed.goals ?? [] };
    }
  } catch (error) {
    console.error('Failed to load onboarding answers:', error);
  }
  return createDefaultAnswers();
}

export function saveOnboardingAnswers(answers: OnboardingAnswers): void {
  try {
    localStorage.setItem(STORAGE_KEYS.ONBOARDING_CATEGORY_ANSWERS, JSON.stringify(answers));
  } catch (error) {
    console.error('Failed to save onboarding answers:', error);
  }
}

export function loadCategoryGroupsDraft(): CategoryGroupDraft[] {
  try {
    const stored = localStorage.getItem(STORAGE_KEYS.ONBOARDING_CATEGORY_DRAFT);
    if (stored) {
      const parsed = JSON.parse(stored);
      return Array.isArray(parsed) ? parsed : [];
    }
  } catch (error) {
    console.error('Failed to load category draft:', error);
  }
  return [];
}

export function saveCategoryGroupsDraft(groups: CategoryGroupDraft[]): void {
  try {
    localStorage.setItem(STORAGE_KEYS.ONBOARDING_CATEGORY_DRAFT, JSON.stringify(groups));
  } catch (error) {
    console.error('Failed to save category draft:', error);
  }
}

export function clearOnboardingCategoryData(): void {
  try {
    localStorage.removeItem(STORAGE_KEYS.ONBOARDING_CATEGORY_ANSWERS);
    localStorage.removeItem(STORAGE_KEYS.ONBOARDING_CATEGORY_DRAFT);
  } catch (error) {
    console.error('Failed to clear onboarding category data:', error);
  }
}
